module.exports = __webpack_public_path__ + "img/AL8000-3-EN.a741f630.jpg";